export class Themes {
    theme_name: string;
    theme_class: string;
    theme_id: number;
    theme_data: object;
}

export class GeneralThemeType {
    css_path: string;
    theme_id: string;
    theme_name: string;
    created_by: string;
}

// export class ThemeList {
//   theme_name: string; value: string; var_address: string;
// }

// export const themeList: ThemeList[] =
//   [
//     { "theme_name": "Default Theme", "value": "default", "var_address": "default.scss" },
//     { "theme_name": "Theme 1", "value": "theme_1", "var_address": "theme_1.scss" }
//   ]

export const themes: Themes[] = [
    {
        "theme_name": "Default Theme",
        "theme_id": 1,
        "theme_class": "default",
        "theme_data": [
            {
                "section_name": "Sidebar",
                "section_fields": [
                    { "label": "Level 1 BG Color", "id": "custom1a", "inputType": "color", "--value": "--sbLevel1BgClr", "name": "sbLevel1BgClr" },
                    { "label": "Level 1 Text Color", "id": "custom1b", "inputType": "color", "--value": "--sbLevel1TxtClr", "name": "sbLevel1TxtClr" },
                    { "label": "Level 1 Active BG Color", "id": "custom1c", "inputType": "color", "--value": "--sbLevel1ActiveBgClr", "name": "sbLevel1ActiveBgClr" },
                    { "label": "Level 1 Active Text Color", "id": "custom1d", "inputType": "color", "--value": "--sbLevel1ActiveTxtClr", "name": "sbLevel1ActiveTxtClr" },
                    { "label": "Level 2 BG Color", "id": "custom2a", "inputType": "color", "--value": "--sbLevel2BgClr", "name": "sbLevel2BgClr" },
                    { "label": "Level 2 Text Color", "id": "custom2b", "inputType": "color", "--value": "--sbLevel2TxtClr", "name": "sbLevel2TxtClr" },
                    { "label": "Level 2 Active BG Color", "id": "custom2c", "inputType": "color", "--value": "--sbLevel2ActiveBgClr", "name": "sbLevel2ActiveBgClr" },
                    { "label": "Level 2 Active Text Color", "id": "custom2d", "inputType": "color", "--value": "--sbLevel2ActiveTxtClr", "name": "sbLevel2ActiveTxtClr" },
                    { "label": "Level 3 BG Color", "id": "custom3a", "inputType": "color", "--value": "--sbLevel3BgClr", "name": "sbLevel3BgClr" },
                    { "label": "Level 3 Text Color", "id": "custom3b", "inputType": "color", "--value": "--sbLevel3TxtClr", "name": "sbLevel3TxtClr" },
                    { "label": "Level 3 Active BG Color", "id": "custom3c", "inputType": "color", "--value": "--sbLevel3ActiveBgClr", "name": "sbLevel3ActiveBgClr" },
                    { "label": "Level 3 Active Text Color", "id": "custom3d", "inputType": "color", "--value": "--sbLevel3ActiveTxtClr", "name": "sbLevel3ActiveTxtClr" },
                    { "label": "Icons", "id": "custom06", "inputType": "selectOption", "optionValues": [{ "label": "Yes", "value": "inline-block" }, { "label": "No", "value": "none" }], "--value": "--sidebarIcon", "name": "sidebarIcon" }
                ]
            },

            {
                "section_name": "Top Menu",
                "section_fields": [
                    { "label": "Main BG Color", "id": "custom7", "inputType": "color", "--value": "--topMenuBgClr", "name": "topMenuBgClr" },
                    { "label": "Main Text Color", "id": "custom8", "inputType": "color", "--value": "--topMenuTxtClr", "name": "topMenuTxtClr" },
                    { "label": "Active BG Color", "id": "custom7a", "inputType": "color", "--value": "--topMenuActiveBgClr", "name": "topMenuActiveBgClr" },
                    { "label": "Active Color", "id": "custom8a", "inputType": "color", "--value": "--topMenuActiveTxtClr", "name": "topMenuActiveTxtClr" },
                    { "label": "Icons", "id": "custom09", "inputType": "selectOption", "optionValues": [{ "label": "Yes", "value": "inline-block" }, { "label": "No", "value": "none" }], "--value": "--topMenuIcon", "name": "topMenuIcon" }
                ]
            },

            {
                "section_name": "Page/Tab Level 1",
                "section_fields": [
                    { "label": "BG Color", "id": "custom10", "inputType": "color", "--value": "--pagemenu1BgClr", "name": "pagemenu1BgClr" },
                    { "label": "Color", "id": "custom11", "inputType": "color", "--value": "--pagemenu1TxtClr", "name": "pagemenu1TxtClr" },
                    { "label": "Active Color", "id": "custom12", "inputType": "color", "--value": "--pagemenu1ActBgClr", "name": "pagemenu1ActBgClr" },
                    { "label": "Active Text Color", "id": "custom120", "inputType": "color", "--value": "--pagemenu1ActTxtClr", "name": "pagemenu1ActTxtClr" },
                    // { "label": "Menu Amend Style", "id": "custom13", "inputType": "selectOption", "optionValues": [{ "label": "Default", "value": "default" }, { "label": "Style 1", "value": "style1" }], "--value": "--pageTab1Icon", "name": "pageTab1Icon" }
                ]
            },
            // {
            //     "section_name": "Page/Tab Level 2",
            //     "section_fields": [
            //         { "label": "BG Color", "id": "custom10a", "inputType": "color", "--value": "--pagemenu2BgClr", "name": "pagemenu2BgClr" },
            //         { "label": "Color", "id": "custom11a", "inputType": "color", "--value": "--pagemenu2TxtClr", "name": "pagemenu2TxtClr" },
            //         { "label": "Active Color", "id": "custom12a", "inputType": "color", "--value": "--pagemenu2ActBgClr", "name": "pagemenu2ActBgClr" },
            //         { "label": "Active Text Color", "id": "custom120a", "inputType": "color", "--value": "--pagemenu2ActTxtClr", "name": "pagemenu2ActTxtClr" },
            //         // { "label": "Menu Amend Style", "id": "custom13a", "inputType": "selectOption", "optionValues": [{ "label": "Default", "value": "default" }, { "label": "Style 1", "value": "style1" }], "--value": "--pageTab2Icon", "name": "pageTab2Icon"  }
            //     ]
            // },
            // {
            //     "section_name": "Page/Tab Level 3",
            //     "section_fields": [
            //         { "label": "BG Color", "id": "custom10c", "inputType": "color", "--value": "--pagemenu3BgClr", "name": "pagemenu3BgClr" },
            //         { "label": "Color", "id": "custom11c", "inputType": "color", "--value": "--pagemenu3TxtClr", "name": "pagemenu3TxtClr" },
            //         { "label": "Active Color", "id": "custom12c", "inputType": "color", "--value": "--pagemenu3ActBgClr", "name": "pagemenu3ActBgClr" },
            //         { "label": "Active Text Color", "id": "custom120c", "inputType": "color", "--value": "--pagemenu3ActTxtClr", "name": "pagemenu3ActTxtClr" },
            //         // { "label": "Menu Amend Style", "id": "custom13c", "inputType": "selectOption", "optionValues": [{ "label": "Default", "value": "default" }, { "label": "Style 1", "value": "style1" }], "--value": "--pageTab3Icon", "name": "pageTab3Icon"  }
            //     ]
            // },
            // {
            //     "section_name": "Common Dropdown",
            //     "section_fields": [
            //         { "label": "BG Color", "id": "custom10b", "inputType": "color", "--value": "--commonDDBgClr", "name": "commonDDBgClr" },
            //         { "label": "Text Color", "id": "custom11b", "inputType": "color", "--value": "--commonDDTxtClr", "name": "commonDDTxtClr" },
            //     ]
            // },
            {
                "section_name": "Form Design",
                "section_fields": [
                    { "label": "Input BG", "id": "custom15", "inputType": "color", "--value": "--inputBg", "name": "inputBg" },
                    { "label": "Input Text", "id": "custom16", "inputType": "color", "--value": "--inputTxt", "name": "inputTxt" },
                    { "label": "Input Focus BG", "id": "custom17", "inputType": "color", "--value": "--inputFocusbg", "name": "inputFocusbg" },
                    { "label": "Input Focus Color", "id": "custom19", "inputType": "color", "--value": "--inputFocusTxt", "name": "inputFocusTxt" },
                    // { "label": "Input Shape", "id": "custom22", "inputType": "selectOption", "optionValues": [{ "label": "Default", "value": "default" }, { "label": "Round Shape", "value": "round_shape" }, { "label": "Border Bottom Shape", "value": "border_bottom_shape" }], "--value": "--inputShape", "name": "inputShape"  },
                    // { "label": "Label Position", "id": "custom23", "inputType": "selectOption", "optionValues": [{ "label": "Default", "value": "default" }, { "label": "Vertical Form Group", "value": "vertical_form_group" }], "--value": "--inputLblPosition", "name": "inputLblPosition"  }
                ]
            },

            // {
            //     "section_name": "Bottom Line",
            //     "section_fields": [
            //         { "label": "Background", "id": "custom24", "inputType": "color", "--value": "--bottomlineBgClr", "name": "bottomlineBgClr" },
            //         { "label": "Text Color", "id": "custom25", "inputType": "color", "--value": "--bottomlineTxtClr", "name": "bottomlineTxtClr" }
            //     ]
            // },
            // {
            //   "section_name": "Footer Strip",
            //   "section_fields": [
            //     { "label": "Background", "id": "custom26", "inputType": "color", "--value": "--footerBgClr", "name": "footerBgClr" },
            //     { "label": "Text Color", "id": "custom27", "inputType": "color", "--value": "--footerTxtClr", "name": "footerTxtClr" }
            //   ]
            // },

            {
                "section_name": "Other Button",
                "section_fields": [
                    { "label": "Default BG", "id": "custom28", "inputType": "color", "--value": "--defaultBgClr", "name": "defaultBgClr" },
                    { "label": "Default Text", "id": "custom29", "inputType": "color", "--value": "--defaultTxtClr", "name": "defaultTxtClr" },
                    { "label": "Primary BG", "id": "custom30", "inputType": "color", "--value": "--primaryBgClr", "name": "primaryBgClr" },
                    { "label": "Primary Text", "id": "custom31", "inputType": "color", "--value": "--primaryTxtClr", "name": "primaryTxtClr" },
                    { "label": "Success Bg", "id": "custom32", "inputType": "color", "--value": "--successBgClr", "name": "successBgClr" },
                    { "label": "Success Text", "id": "custom33", "inputType": "color", "--value": "--successTxtClr", "name": "successTxtClr" },
                    { "label": "Danger BG", "id": "custom34", "inputType": "color", "--value": "--dangerBgClr", "name": "dangerBgClr" },
                    { "label": "Danger Text", "id": "custom35", "inputType": "color", "--value": "--dangerTxtClr", "name": "dangerTxtClr" },
                    { "label": "Info BG", "id": "custom36", "inputType": "color", "--value": "--infoBgClr", "name": "infoBgClr" },
                    { "label": "Info Text", "id": "custom37", "inputType": "color", "--value": "--infoTxtClr", "name": "infoTxtClr" },
                    { "label": "Warning BG", "id": "custom38", "inputType": "color", "--value": "--warningBgClr", "name": "warningBgClr" },
                    { "label": "Warning Text", "id": "custom39", "inputType": "color", "--value": "--warningTxtClr", "name": "warningTxtClr" },
                    { "label": "Secondary BG", "id": "custom40", "inputType": "color", "--value": "--secondaryBgClr", "name": "secondaryBgClr" },
                    { "label": "Secondary Text", "id": "custom41", "inputType": "color", "--value": "--secondaryTxtClr", "name": "secondaryTxtClr" },
                ]
            },
            {
                "section_name": "Grid Colors",
                "section_fields": [
                    { "label": "Header BG", "id": "custom42g", "inputType": "color", "--value": "--gridHeaderBgClr", "name": "gridHeaderBgClr" },
                    { "label": "Header Text", "id": "custom43g", "inputType": "color", "--value": "--gridHeaderTxtClr", "name": "gridHeaderTxtClr" },
                    { "label": "Grid BG", "id": "custom44g", "inputType": "color", "--value": "--gridBgClr", "name": "gridBgClr" },
                    { "label": "Geid Text", "id": "custom45g", "inputType": "color", "--value": "--gridTxtClr", "name": "gridTxtClr" },
                    { "label": "Select BG", "id": "custom46g", "inputType": "color", "--value": "--gridSelectBgClr", "name": "gridSelectBgClr" },
                    { "label": "Select Text", "id": "custom47g", "inputType": "color", "--value": "--gridSelectTxtClr", "name": "gridSelectTxtClr" },
                ]
            },
            {
                "section_name": "Body",
                "section_fields": [
                    { "label": "Background", "id": "custom42", "inputType": "color", "--value": "--bodyBgClr", "name": "bodyBgClr" },
                    // { "label": "Padding", "id": "custom43", "inputType": "color", "--value": "--bodyPadding", "name": "bodyPadding" }
                ]
            },
            // {
            //   "section_name": "Container",
            //   "section_fields": [
            //     { "label": "Background", "id": "custom44", "inputType": "color", "--value": "containerBg", "name": "containerBg" },
            //   ]
            // },
            // {
            //   "section_name": "Card",
            //   "section_fields": [
            //     { "label": "Card Header BG", "id": "custom45", "inputType": "color", "--value": "--cardheaderBgClr", "name": "cardheaderBgClr" },
            //     { "label": "Card Header Txt", "id": "custom46", "inputType": "color", "--value": "--cardheaderTxtClr", "name": "cardheaderTxtClr" }
            //   ]
            // },

        ]
    }
]


export const default_color = [
    {
        "theme_name": "Default Theme",
        "theme_id": 1,
        "theme_class": "default",
        "theme_data": [{
            "section_fields": [
                { "--value": "", "name": "defaultBgClr" },
                { "--value": "", "name": "defaultTxtClr" },
                { "--value": "", "name": "primaryBgClr" },
                { "--value": "", "name": "primaryTxtClr" },
                { "--value": "", "name": "successBgClr" },
                { "--value": "", "name": "successTxtClr" },
                { "--value": "", "name": "dangerBgClr" },
                { "--value": "", "name": "dangerTxtClr" },
                { "--value": "", "name": "infoBgClr" },
                { "--value": "", "name": "infoTxtClr" },
                { "--value": "", "name": "warningBgClr" },
                { "--value": "", "name": "warningTxtClr" },
                { "--value": "", "name": "secondaryBgClr" },
                { "--value": "", "name": "secondaryTxtClr" },
                { "--value": "", "name": "sbLevel1BgClr" },
                { "--value": "", "name": "sbLevel1TxtClr" },
                { "--value": "", "name": "sbLevel1ActiveBgClr" },
                { "--value": "", "name": "sbLevel1ActiveTxtClr" },
                { "--value": "", "name": "sbLevel2BgClr" },
                { "--value": "", "name": "sbLevel2TxtClr" },
                { "--value": "", "name": "sbLevel2ActiveBgClr" },
                { "--value": "", "name": "sbLevel2ActiveTxtClr" },
                { "--value": "", "name": "sbLevel3BgClr" },
                { "--value": "", "name": "sbLevel3TxtClr" },
                { "--value": "", "name": "sbLevel3ActiveBgClr" },
                { "--value": "", "name": "sbLevel3ActiveTxtClr" },
                { "--value": "", "name": "mainSidebarBgClr" },
                { "--value": "", "name": "mainSidebarTxtClr" },
                { "--value": "", "name": "secSidebarBgClr" },
                { "--value": "", "name": "secSidebarIconBgClr" },
                { "--value": "", "name": "secSidebarIconTxtClr" },
                { "--value": "", "name": "topMenuBgClr" },
                { "--value": "", "name": "topMenuTxtClr" },
                { "--value": "", "name": "topMenuActiveBgClr" },
                { "--value": "", "name": "topMenuActiveTxtClr" },
                { "--value": "", "name": "pagemenu1BgClr" },
                { "--value": "", "name": "pagemenu1TxtClr" },
                { "--value": "", "name": "pagemenu1ActBgClr" },
                { "--value": "", "name": "pagemenu1ActTxtClr" },
                { "--value": "", "name": "pagemenu2BgClr" },
                { "--value": "", "name": "pagemenu2TxtClr" },
                { "--value": "", "name": "pagemenu2ActBgClr" },
                { "--value": "", "name": "pagemenu2ActTxtClr" },
                { "--value": "", "name": "pagemenu3BgClr" },
                { "--value": "", "name": "pagemenu3TxtClr" },
                { "--value": "", "name": "pagemenu3ActBgClr" },
                { "--value": "", "name": "pagemenu3ActTxtClr" },
                { "--value": "", "name": "commonDDBgClr" },
                { "--value": "", "name": "commonDDTxtClr" },
                { "--value": "", "name": "inputBg" },
                { "--value": "", "name": "inputTxt" },
                { "--value": "", "name": "inputFocusbg" },
                { "--value": "", "name": "inputFocusTxt" },
                { "--value": "", "name": "bottomlineBgClr" },
                { "--value": "", "name": "bottomlineTxtClr" },
                { "--value": "", "name": "footerBgClr" },
                { "--value": "", "name": "footerTxtClr" },
                { "--value": "", "name": "defaultBgClr" },
                { "--value": "", "name": "defaultTxtClr" },
                { "--value": "", "name": "primaryBgClr" },
                { "--value": "", "name": "primaryTxtClr" },
                { "--value": "", "name": "successBgClr" },
                { "--value": "", "name": "successTxtClr" },
                { "--value": "", "name": "dangerBgClr" },
                { "--value": "", "name": "dangerTxtClr" },
                { "--value": "", "name": "infoBgClr" },
                { "--value": "", "name": "infoTxtClr" },
                { "--value": "", "name": "cardheaderBgClr" },
                { "--value": "", "name": "cardheaderTxtClr" },
                { "--value": "", "name": "bodyBgClr" },
                { "--value": "", "name": "bodyPadding" },
                { "--value": "", "name": "containerBg" },
                { "--value": "", "name": "gridHeaderBgClr" },
                { "--value": "", "name": "gridHeaderTxtClr" },
                { "--value": "", "name": "gridBgClr" },
                { "--value": "", "name": "gridTxtClr" },
                { "--value": "", "name": "gridSelectBgClr" },
                { "--value": "", "name": "gridSelectTxtClr" },
            ]
        }
        ]
    }

];

export const colorSchemes = [
    {
        "theme_id": '1',
        "color_skins": [
            {
                "color_scheme": '1.1',
                "theme_data": [
                    { "purple": "rgba(13, 110, 253, 1)" },
                    { "dark-gray": "rgba(108, 117, 125, 1)" },
                    { "sky": "rgba(13, 202, 240, 1)" },
                    { "green": "rgba(25, 135, 84, 1)" },
                    { "orange": "rgba(255, 193, 7, 1)" },
                    { "magento": "rgba(220, 53, 69, 1)" },
                    { "white": "rgba(255, 255, 255, 1)" },
                    { "white_1": "rgba(255, 255, 255, 1)" },
                    { "sky_1": "rgba(255, 255, 255, 1)" },
                    { "black": "rgba(0, 0, 0, 1)" },
                    { "light-purple": "rgba(237, 236, 253, 1)" },
                    { "light-gray": "rgba(248,249,250, 1)" },
                    { "mid-light-gray": "rgba(185, 183, 189, 1)" },
                    { "light-yellow": "rgba(244, 235, 208, 1)" },
                    { "light-sky": "rgba(195, 224, 229, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                    // {"display-Icon" : "inline-block"},
                    // {"display-LblPos" : "left"},
                    // {"display-Shape" : "normal"},
                ]
            },
            {
                "color_scheme": '1.2',
                "theme_data": [
                    { "purple": "rgba(149, 147, 147, 1)" },
                    { "dark-gray": "rgba(108, 117, 125, 1)" },
                    { "sky": "rgba(13, 202, 240, 1)" },
                    { "green": "rgba(25, 135, 84, 1)" },
                    { "orange": "rgba(255, 193, 7, 1)" },
                    { "magento": "rgba(220, 53, 69, 1)" },
                    { "white": "rgba(238, 237, 237, 1)" },
                    { "sky_1": "rgba(238, 238, 238, 1)" },
                    { "white_1": "rgba(0, 0, 0, 1)" },
                    { "black": "rgba(0, 0, 0, 1)" },
                    { "light-purple": "rgba(237, 236, 253, 1)" },
                    { "light-gray": "rgba(238, 238, 238, 1)" },
                    { "mid-light-gray": "rgba(185, 183, 189, 1)" },
                    { "light-yellow": "rgba(244, 235, 208, 1)" },
                    { "light-sky": "rgba(195, 224, 229, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                    // {"display-Icon" : "inline-block"},
                    // {"display-LblPos" : "left"},
                    // {"display-Shape" : "normal"},
                ]
            },
            {
                "color_scheme": '1.3',
                "theme_data": [
                    { "purple": "rgba(94, 187, 187, 1)" },
                    { "dark-gray": "rgba(122, 158, 159, 1)" },
                    { "sky": "rgba(79, 99, 103, 1)" },
                    { "green": "rgba(55, 160, 0, 1)" },
                    { "orange": "rgba(223, 129, 9, 1)" },
                    { "magento": "rgba(254, 94, 85, 1)" },
                    { "white": "rgba(185, 216, 216, 1)" },
                    { "white_1": "rgba(0, 0, 0, 1)" },
                    { "sky_1": "rgba(185, 216, 216, 1)" },
                    { "mid-light-gray": "rgba(255, 255, 255, 1)" },
                    { "black": "rgba(45, 45, 45, 1)" },
                    { "light-purple": "rgba(238, 245, 219, 1)" },
                    { "light-gray": "rgba(238, 238, 238, 1)" },
                    { "light-yellow": "rgba(185, 216, 216, 1)" },
                    { "light-sky": "rgba(184, 216, 216, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                    // {"display-Icon" : "inline-block"},
                    // {"display-LblPos" : "left"},
                    // {"display-Shape" : "normal"},
                ]
            },
            {
                "color_scheme": '1.4',
                "theme_data": [
                    { "purple": "rgba(181, 154, 220, 1)" },
                    { "dark-gray": "rgba(174, 189, 56, 1)" },
                    { "sky": "rgba(89, 130, 52, 1)" },
                    { "green": "rgba(55, 160, 0, 1)" },
                    { "orange": "rgba(240, 208, 67, 1)" },
                    { "magento": "rgba(224, 214, 238, 1)" },
                    { "white": "rgba(224, 214, 238, 1)" },
                    { "sky_1": "rgba(185, 216, 216, 1)" },
                    { "white_1": "rgba(0, 0, 0, 1)" },
                    { "black": "rgba(41, 53, 70, 1)" },
                    { "light-purple": "rgba(201, 203, 230, 1)" },
                    { "light-gray": "rgba(238, 238, 238, 1)" },
                    { "mid-light-gray": "rgba(255, 255, 255, 1)" },
                    { "light-yellow": "rgba(253, 239, 119, 1)" },
                    { "light-sky": "rgba(247, 233, 238, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                    // {"display-Icon" : "inline-block"},
                    // {"display-LblPos" : "left"},
                    // {"display-Shape" : "normal"},
                ]
            },
            {
                "color_scheme": '1.5',
                "theme_data": [
                    { "purple": "rgba(102, 129, 165, 1)" },
                    { "dark-gray": "rgba(0, 67, 105, 1)" },
                    { "sky": "rgba(1, 148, 154, 1)" },
                    { "green": "rgba(194, 109, 188, 1)" },
                    { "orange": "rgba(201, 224, 255, 1)" },
                    { "magento": "rgba(239, 14, 14, 1)" },
                    { "white": "rgba(201, 224, 255, 1)" },
                    { "sky_1": "rgba(185, 216, 216, 1)" },
                    { "white_1": "rgba(255, 255, 255, 1)" },
                    { "black": "rgba(41, 53, 70, 1)" },
                    { "light-purple": "rgba(247, 233, 238, 1)" },
                    { "light-gray": "rgba(238, 238, 238, 1)" },
                    { "mid-light-gray": "rgba(106, 148, 204, 1)" },
                    { "light-yellow": "rgba(204, 204, 204, 1)" },
                    { "light-sky": "rgba(253, 239, 119, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                    // {"display-Icon" : "inline-block"},
                    // {"display-LblPos" : "left"},
                    // {"display-Shape" : "normal"},
                ]
            },
            {
                "color_scheme": '1.6',
                "theme_data": [
                    { "purple": "rgba(194, 170, 103, 1)" },
                    { "dark-gray": "rgba(126, 105, 17, 1)" },
                    { "sky": "rgba(38, 78, 112, 1)" },
                    { "green": "rgba(38, 78, 112, 1)" },
                    { "orange": "rgba(244, 132, 15, 1)" },
                    { "magento": "rgba(249, 180, 171, 1)" },
                    { "white": "rgba(255, 249, 233, 1)" },
                    { "sky_1": "rgba(185, 216, 216, 1)" },
                    { "white_1": "rgba(255, 255, 255, 1)" },
                    { "black": "rgba(30, 30, 30, 1)" },
                    { "light-purple": "rgba(187, 212, 206, 1)" },
                    { "light-gray": "rgba(238, 238, 238, 1)" },
                    { "mid-light-gray": "rgba(204, 180, 118, 1)" },
                    { "light-yellow": "rgba(255, 243, 230, 1)" },
                    { "light-sky": "rgba(200, 224, 255, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                    // {"display-Icon" : "inline-block"},
                    // {"display-LblPos" : "left"},
                    // {"display-Shape" : "normal"},
                ]
            },
            {
                "color_scheme": '1.7',
                "theme_data": [
                    { "purple": "rgba(189, 149, 175, 1)" },
                    { "dark-gray": "rgba(75, 154, 187, 1)" },
                    { "sky": "rgba(38, 92, 126, 1)" },
                    { "green": "rgba(75, 183, 186, 1)" },
                    { "orange": "rgba(252, 179, 24, 1)" },
                    { "magento": "rgba(163, 205, 59, 1)" },
                    { "white": "rgba(239, 225, 234, 1)" },
                    { "sky_1": "rgba(185, 216, 216, 1)" },
                    { "white_1": "rgba(255, 255, 255, 1)" },
                    { "black": "rgba(30, 30, 30, 1)" },
                    { "light-purple": "rgba(187, 212, 206, 1)" },
                    { "light-gray": "rgba(238, 238, 238, 1)" },
                    { "mid-light-gray": "rgba(189, 151, 176, 1)" },
                    { "light-yellow": "rgba(255, 243, 230, 1)" },
                    { "light-sky": "rgba(200, 224, 255, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                    // {"display-Icon" : "inline-block"},
                    // {"display-LblPos" : "left"},
                    // {"display-Shape" : "normal"},
                ]
            },
        ]
    },
    {
        "theme_id": '2',
        "color_skins": [
            {
                "color_scheme": '2.1',
                "theme_data": [
                    { "purple": "rgba(13, 110, 253, 1)" },
                    { "light-purple": "rgba(59, 68, 82, 1)" },
                    { "dark-gray": "rgba(255, 255, 255, 1)" },
                    { "sky": "rgba(226, 166, 96, 1)" },
                    { "green": "rgba(55, 160, 0, 1)" },
                    { "orange": "rgba(255, 127, 0, 1)" },
                    { "light-gray": "rgba(53, 60, 72, 1)" },
                    { "mid-light-gray": "rgba(42, 47, 51, 1)" },
                    { "magento": "rgba(251, 86, 35, 1)" },
                    { "white": "rgba(255, 255, 255, 1)" },
                    { "black": "rgba(33, 37, 41, 1)" },
                    { "light-yellow": "rgba(250, 240, 170, 1)" },
                    { "light-sky": "rgba(53, 60, 72, 1)" },
                    // {"display-Icon" : "inline-block"},
                    // {"display-LblPos" : "left"},
                    // {"display-Shape" : "normal"},
                    { "mid-blue": "rgba(107, 144, 191, 1)" },
                    { "black_1": "rgba(173, 181, 189, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                ]
            },
            {
                "color_scheme": '2.2',
                "theme_data": [
                    { "purple": "rgba(43, 45, 66, 1)" },
                    { "light-purple": "rgba(141, 153, 174, 1)" },
                    { "dark-gray": "rgba(237, 242, 244, 1)" },
                    { "sky": "rgba(239, 35, 60, 1)" },
                    { "green": "rgba(55, 160, 0, 1)" },
                    { "orange": "rgba(255, 127, 0, 1)" },
                    { "light-gray": "rgba(53, 60, 72, 1)" },
                    { "mid-light-gray": "rgba(63, 86, 99, 1)" },
                    { "magento": "rgba(251, 86, 35, 1)" },
                    { "white": "rgba(255, 255, 255, 1)" },
                    { "black": "rgba(0, 0, 0, 1)" },
                    { "light-yellow": "rgba(250, 240, 170, 1)" },
                    { "light-sky": "rgba(53, 60, 72, 1)" },
                    // {"display-Icon" : "inline-block"},
                    //   {"display-LblPos" : "left"},
                    //   {"display-Shape" : "normal"},
                    { "mid-blue": "rgba(107, 144, 191, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                ]
            },
        ]
    },
    {
        "theme_id": '3',
        "color_skins": [
            {
                "color_scheme": '3.1',
                "theme_data": [
                    { "purple": "rgba(43, 45, 66, 1)" },
                    { "purple_1": "rgba(77, 49, 44, 1)" },
                    { "light-purple": "rgba(59, 68, 82, 1)" },
                    { "dark-gray": "rgba(255, 255, 255, 1)" },
                    { "sky": "rgba(226, 166, 96, 1)" },
                    { "green": "rgba(55, 160, 0, 1)" },
                    { "orange": "rgba(255, 127, 0, 1)" },
                    { "light-gray": "rgba(53, 60, 72, 1)" },
                    { "mid-light-gray": "rgba(42, 47, 51, 1)" },
                    { "magento": "rgba(251, 86, 35, 1)" },
                    { "white": "rgba(255, 255, 255, 1)" },
                    { "black": "rgba(33, 37, 41, 1)" },
                    { "light-yellow": "rgba(250, 240, 170, 1)" },
                    { "light-sky": "rgba(53, 60, 72, 1)" },
                    // {"display-Icon" : "inline-block"},
                    // {"display-LblPos" : "left"},
                    // {"display-Shape" : "normal"},
                    { "mid-blue": "rgba(107, 144, 191, 1)" },
                    { "black_1": "rgba(173, 181, 189, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                ]
            },
            {
                "color_scheme": '3.2',
                "theme_data": [
                    { "purple": "rgba(43, 45, 66, 1)" },
                    { "--purple_1": "rgba(77, 49, 44, 1)" },
                    { "light-purple": "rgba(141, 153, 174, 1)" },
                    { "dark-gray": "rgba(237, 242, 244, 1)" },
                    { "sky": "rgba(239, 35, 60, 1)" },
                    { "green": "rgba(55, 160, 0, 1)" },
                    { "orange": "rgba(255, 127, 0, 1)" },
                    { "light-gray": "rgba(53, 60, 72, 1)" },
                    { "mid-light-gray": "rgba(63, 86, 99, 1)" },
                    { "magento": "rgba(251, 86, 35, 1)" },
                    { "white": "rgba(255, 255, 255, 1)" },
                    { "black": "rgba(0, 0, 0, 1)" },
                    { "light-yellow": "rgba(250, 240, 170, 1)" },
                    { "light-sky": "rgba(53, 60, 72, 1)" },
                    // {"display-Icon" : "inline-block"},
                    //   {"display-LblPos" : "left"},
                    //   {"display-Shape" : "normal"},
                    { "mid-blue": "rgba(107, 144, 191, 1)" },
                    { "transparent": "rgba(0, 0, 0, 0)" },
                ]
            },
        ]
    },

];




export const backgrounds = [
    { "label": "Default (Home BG)", "value": "default" },
    { "label": "Background 01", "value": "bg-1" },
    { "label": "Background 02", "value": "bg-2" },
    { "label": "Background 03", "value": "bg-3" },
    { "label": "Background 04", "value": "bg-4" },
    { "label": "Background 05", "value": "bg-5" },
    { "label": "Background 06", "value": "bg-6" },
    { "label": "Background 07", "value": "bg-7" },
    { "label": "Background 08", "value": "bg-8" },
    { "label": "Background 09", "value": "bg-9" },
    { "label": "Background 10", "value": "bg-10" },
    { "label": "Background 11", "value": "bg-11" },
    { "label": "Background 12", "value": "bg-12" },
    { "label": "Background 13", "value": "bg-13" },
    { "label": "Background 14", "value": "bg-14" },
    { "label": "Background 15", "value": "bg-15" },
    { "label": "Background 16", "value": "bg-16" },
    { "label": "Background 17", "value": "bg-17" },
    { "label": "Background 18", "value": "bg-18" }
];

export const generalTheme: GeneralThemeType[] = [
    { "css_path": "assets/css/themes/default.css", "theme_id": '1', "theme_name": "Default", "created_by": "Ujagar Singh Meena" },
    { "css_path": "assets/css/themes/theme1.css", "theme_id": '2', "theme_name": "Theme 1", "created_by": "Faizan Gouri" },
    { "css_path": "assets/css/themes/theme2.css", "theme_id": '3', "theme_name": "Theme 2", "created_by": "Varun Jain" },
    { "css_path": "assets/css/themes/theme3.css", "theme_id": '4', "theme_name": "Theme 3", "created_by": "Faizan" },
];
// export const generalTheme: GeneralThemeType[] = [
//     { "css_path": "assets/css/themes/default.css", "theme_id": '1', "theme_name": "Default", "created_by": "Ujagar Singh Meena" },
//     { "css_path": "assets/css/themes/theme1.css", "theme_id": '2', "theme_name": "Theme 1", "created_by": "Faizan Gouri" },
//     { "css_path": "assets/css/themes/theme2.css", "theme_id": '3', "theme_name": "Theme 2", "created_by": "Varun Jain" },
//     { "css_path": "assets/css/themes/theme3.css", "theme_id": '4', "theme_name": "Theme 3", "created_by": "Faizan" }, 
// ];